import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectAccessToken } from '../../../slices/staffSlice';
import { authStaff } from "../../../utils/constants";
import { fetchRequests } from "../../../Requests/getRequests";
import { show } from '../../../slices/toastSlice';
import { Loader } from "../../../components";

// Clears a staff member's 2FA (lost phone and backup codes).
// They set it up again with a new QR code at their next sign-in.
function ResetMfa({ _id, enabled, onReset }) {

    const navigate = useNavigate();
    const accessToken = useSelector(selectAccessToken);
    const dispatch = useDispatch();
    const [confirmed, setConfirmed] = useState(false);
    const [process, setProcess] = useState(false);

    const handleAction = async () => {
        if (!confirmed) {
            setConfirmed(true);
            return;
        }

        setProcess(true);
        const res = await fetchRequests(`/auth/staff/mfa/reset`, "POST", authStaff(accessToken), {}, { _id });
        setProcess(false);
        setConfirmed(false);

        if (res?.code === 401) {
            sessionStorage.clear();
            navigate("/login");
            dispatch(show({ type: "error", state: true, message: "Your session has expired. Please login to continue." }));
            return;
        }

        dispatch(show({ type: res?.err ? "error" : "success", state: true, message: res?.err || res?.message }));
        if (!res?.err && onReset) onReset();
    };

    if (!enabled) {
        return <p className="text-xs text-gray-400">Not set up yet. They will be asked to set it up at their next sign-in.</p>;
    }

    return (
        <div className={confirmed ? "rounded-lg border border-amber-100 bg-amber-50 p-4" : ""}>
            {confirmed && (
                <p className="text-sm text-amber-800 mb-3">
                    Only do this if you have confirmed it is really them (in person or by phone). Their current authenticator and backup codes will stop working.
                </p>
            )}
            <div className="flex items-center gap-2">
                <button
                    type="button"
                    onClick={handleAction}
                    disabled={process}
                    className="inline-flex items-center gap-2 rounded-lg bg-amber-600 hover:bg-amber-700 px-3.5 py-2 text-sm font-semibold text-white disabled:opacity-60"
                >
                    {process ? <Loader color="text-white" size="w-4 h-4" /> : confirmed ? "Yes, reset 2FA" : "Reset 2FA"}
                </button>
                {confirmed && (
                    <button type="button" onClick={() => setConfirmed(false)} className="text-sm text-gray-500 hover:underline">
                        Cancel
                    </button>
                )}
            </div>
        </div>
    );
}

export default ResetMfa;
